type Props = {
  name: string;
  title?: string;
  photoUrl?: string;
  bio: string;
};

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function InstructorBio({ name, title, photoUrl, bio }: Props) {
  return (
    <div class="instructor-bio">
      {photoUrl ? (
        <img class="instructor-bio__photo" src={photoUrl} alt={name} />
      ) : (
        <div class="instructor-bio__initials">{getInitials(name)}</div>
      )}
      <div class="instructor-bio__body">
        <h3 class="instructor-bio__name">{name}</h3>
        {title && <p class="instructor-bio__title">{title}</p>}
        <p class="instructor-bio__text">{bio}</p>
      </div>
    </div>
  );
}
